<page-header />

<div class="cmc-detail-grid">
  <app-board-next-appointment></app-board-next-appointment>

  @if (numberMinutes() !== null) {
    <section class="cmc-box cmc-topic--verwaltung">
      <header class="cmc-box__head">
        <span class="cmc-box__icon"><mat-icon>description</mat-icon></span>
        <h2 class="cmc-box__title">{{ 'board.appointments.title_minutes' | translate }}</h2>
      </header>
      <p class="m-0">{{ 'board.appointments.info_number_minutes' | translate: { numberMinutes: numberMinutes() } }}</p>
      <div class="cmc-info-row">
        <mat-icon>event</mat-icon>
        <span>{{ 'board.appointments.info_last_minutes' | translate }} {{ lastDate() | date: 'dd.MM.yyyy' }}</span>
      </div>
      <div class="cmc-form-actions">
        <button mat-stroked-button routerLink="../appointments">
          {{ 'board.appointments.label_appointment_overview' | translate }}
          <mat-icon iconPositionEnd class="cmc-flip-rtl">arrow_forward</mat-icon>
        </button>
      </div>
    </section>
  }
</div>
